import type { Certification } from '@portfolio/shared';
import type { JSX } from 'react';

import { formatAwardDate } from '@/lib/formatDate';

interface CertificationMetaProps {
  certification: Certification;
}

/**
 * Issuer, followed by the award date where a certificate documents one, the
 * year where only that is known, and nothing at all otherwise. Dates are never
 * inferred to fill the gap.
 */
export function CertificationMeta({ certification }: CertificationMetaProps): JSX.Element {
  const { issuer, awardedOn, year } = certification;

  if (awardedOn) {
    return (
      <>
        {issuer}
        <span aria-hidden="true"> · </span>
        <time dateTime={awardedOn}>{formatAwardDate(awardedOn)}</time>
      </>
    );
  }

  if (year !== null) {
    return (
      <>
        {issuer}
        <span aria-hidden="true"> · </span>
        {year}
      </>
    );
  }

  return <>{issuer}</>;
}
